"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardCommandProcessing = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var react_1 = require("react");
var useDashboardCommand_1 = require("./useDashboardCommand");
/**
 * @internal
 */
exports.useDashboardCommandProcessing = function (_a) {
    var _b;
    var commandCreator = _a.commandCreator, successEvent = _a.successEvent, errorEvent = _a.errorEvent, onSuccess = _a.onSuccess, onError = _a.onError, onBeforeRun = _a.onBeforeRun;
    var _c = tslib_1.__read(react_1.useState(), 2), status = _c[0], setStatus = _c[1];
    var run = useDashboardCommand_1.useDashboardCommand(commandCreator, (_b = {},
        _b[successEvent] = function (event) {
            setStatus("success");
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(event);
        },
        _b[errorEvent] = function (event) {
            setStatus("error");
            onError === null || onError === void 0 ? void 0 : onError(event);
        },
        _b), function (cmd) {
        setStatus("running");
        onBeforeRun === null || onBeforeRun === void 0 ? void 0 : onBeforeRun(cmd);
    });
    return {
        run: run,
        status: status,
    };
};
//# sourceMappingURL=useDashboardCommandProcessing.js.map